import { STICKER } from '@/entities/label';
import { LabelEditor } from '@/widgets/label-editor';
import { useDocumentTitle } from '@/shared/lib';

// /type1-sticker-4x6.html: one 4"×6" sticker for a thermal printer, portrait or landscape, 1 or 2 products.
export function StickerPage() {
  useDocumentTitle(STICKER.title);
  return <LabelEditor spec={STICKER} />;
}
